import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Authorization from "../../../../component/Authorization";
import { DebounceSelect } from "../../../../component/DebounceSelect";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { User, UserUI } from "../entity/user.model";
import { userService } from "../service/user.service";
import { RouteContext } from "./components/route.context";
import UserTable from "./components/UserTable";

function Users() {
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [users, setUsers] = useState<User[]>([]);
  let navigate = useNavigate();
  const [user, setUser] = useState<User>();

  useEffect(() => {
    if (state.routeId && state.routeId !== "") {
      getUsers(state.routeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  const getUsers = (routeId?: string) => {
    dispatch({ type: spinActions.BLOCK });
    userService
      .getUsers(user?.username, routeId)
      .then((_users: User[]) => {
        setUsers(_users);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  return (
    <>
      <MPageHeader crumbs={["Хэрэглэгчид"]} />

      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h6 className="card-title">Хэрэглэгчид</h6>
            <Authorization roles={["user-full", "user-manage"]}>
              <div className="header-elements">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => navigate("/users/add")}
                >
                  <i className="icon-user-plus mr-2"></i>
                  Хэрэглэгч нэмэх
                </button>
              </div>
            </Authorization>
          </div>
          <div className="card-body">
            <div className="d-flex bd-highlight example-parent mb-2">
              <DebounceSelect<UserUI>
                showSearch
                placeholder="Хайх"
                allowClear
                onChange={(value) => {
                  setUser(value);
                }}
                fetchOptions={(search) => {
                  return userService.getUsers(search, state.routeId);
                }}
                style={{ maxWidth: "calc(100% - 91px)", width: "250px" }}
              />

              <button
                type="submit"
                className="btn btn-sm btn-primary ml-2"
                onClick={() => {
                  getUsers(state.routeId);
                }}
              >
                <i className="icon-search4 mr-2" />
                Хайх
              </button>
            </div>
            <UserTable users={users} onReload={() => getUsers()}></UserTable>
          </div>
        </div>
      </div>
    </>
  );
}

export default Users;
